import "./App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";

import HomePage from "./pages/HomePage";

const DienstenPage = lazy(() => import("./pages/DienstenPage"));
const OverOnsPage = lazy(() => import("./pages/OverOnsPage"));
const OffertePage = lazy(() => import("./pages/OffertePage"));
const OfferteBedanktPage = lazy(() => import("./pages/OfferteBedanktPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const CityPage = lazy(() => import("./pages/CityPage"));
const BlogIndexPage = lazy(() => import("./pages/BlogIndexPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const ReviewsPage = lazy(() => import("./pages/ReviewsPage"));
const VoorNaPage = lazy(() => import("./pages/VoorNaPage"));
const AdminLoginPage = lazy(() => import("./pages/AdminLoginPage"));
const AdminDashboardPage = lazy(() => import("./pages/AdminDashboardPage"));

const PageLoader = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="w-10 h-10 border-4 border-neutral-200 border-t-yellow-400 rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/diensten" element={<DienstenPage />} />
              <Route path="/diensten/:slug" element={<LandingPage />} />
              <Route path="/fitnessapparatuur-verhuizen/:city" element={<CityPage />} />
              <Route path="/blog" element={<BlogIndexPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/voor-en-na" element={<VoorNaPage />} />
              <Route path="/over-ons" element={<OverOnsPage />} />
              <Route path="/offerte" element={<OffertePage />} />
              <Route path="/offerte-bedankt" element={<OfferteBedanktPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            </Routes>
          </Suspense>
          <FloatingWhatsApp />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
